export const extra = {
  it: {
    nav: {
      mosaic: "Il Mosaico",
      press: "Stampa",
      mission: "La Missione",
    },
    mosaic: {
      eyebrow: "Il ritratto in formazione",
      title: "Il Mosaico",
      sub: "Ogni volto caricato accende un frammento del ritratto di Gandhi. Il mosaico si aggiorna in tempo reale man mano che l'umanità si unisce.",
      faces: "volti",
      zoomHint: "Zoom: rotella del mouse · Trascina per esplorare il ritratto",
      today: "Oggi",
      simulation: "Simulazione 2027",
      simBadge: "SIMULAZIONE ARTISTICA",
      simNote: "Visione artistica: così apparirà il ritratto quando 500.000 volti si saranno uniti. Ogni tessera è un volto.",
      note: "Le tessere ancora spente sulla sagoma attendono un volto. Ogni pixel dorato è una persona che ha detto: ci sono anch'io.",
      galleryTitle: "I volti già nel ritratto",
      galleryEmpty: "Nessun volto ancora approvato. Il primo volto del ritratto potrebbe essere il tuo.",
    },
    gandhi: {
      simLink: "Guarda la simulazione del mosaico finale",
    },
    mission: {
      kicker: "IL TUO POSTO LASCIA UN SEGNO.",
      lead: "Entra in Humanity Mosaic.\nDiventa parte di un'opera costruita dalle persone di tutto il mondo.\nScegli il tuo spazio.\nInserisci la tua immagine, la tua storia, il tuo messaggio.\nLascia una traccia di te.",
      charity: "Una parte delle risorse generate dal progetto sarà destinata a un progetto umanitario a favore dei bambini e alla realizzazione della Stamperia Antica di Subiaco, nella città in cui, nel 1465, ebbe inizio la storia della stampa a caratteri mobili in Italia.",
      line1: "UN POSTO PER TE.",
      line2: "UN POSTO NEL MONDO PER UN BAMBINO.",
      line3: "UN PEZZO DI STORIA DA RESTITUIRE AL FUTURO.",
      gesture: "Un gesto digitale. Due segni nel mondo reale.",
      signature: "Migliaia di persone. Un'unica opera. Una traccia nel mondo",
      counterLabel: "pixel venduti — una parte delle risorse va alla missione",
      moreLink: "Scopri la missione",
    },
    missionPage: {
      eyebrow: "Azione umanitaria e culturale",
      title: "La Missione",
      lead: "Humanity Mosaic non è solo un'opera d'arte collettiva: ogni pixel venduto lascia un segno nel mondo reale. Una parte delle risorse generate dal progetto sostiene due realtà: un progetto umanitario a favore dei bambini e la storia della stampa di Subiaco.",
      aibiEyebrow: "01 — I BAMBINI",
      aibiTitle: "Progetto umanitario",
      aibiBody: "Una parte delle risorse generate da Humanity Mosaic sarà destinata a un progetto umanitario a favore dei bambini. Perché se Humanity Mosaic invita ogni persona a trovare il proprio posto all'interno di una grande opera, esiste un posto infinitamente più importante: quello che ogni bambino dovrebbe poter trovare nella vita e negli affetti. I dettagli del progetto saranno annunciati all'attivazione della campagna.",
      stampEyebrow: "02 — LA STORIA",
      stampTitle: "La Stamperia Antica di Subiaco",
      stampBody: "Nel 1465, tra le mura del monastero di Santa Scolastica a Subiaco, Konrad Sweynheym e Arnold Pannartz stamparono il primo libro a caratteri mobili d'Italia: in quella città è nata la storia italiana della stampa. Il progetto della Stamperia Antica riporta in vita quei gesti — il torchio in legno, i caratteri composti a mano, la carta — e una parte delle risorse di Humanity Mosaic contribuirà alla sua realizzazione.",
      capTorchio: "Il torchio in legno, ricostruito come nel Quattrocento",
      capTipi: "Caratteri mobili composti a mano, pagina per pagina",
      capFogli: "I fogli stampati della Stamperia Antica",
      counterEyebrow: "03 — IL TUO CONTRIBUTO",
      counterLabel: "pixel già venduti — una parte delle risorse va alla missione",
      counterGoal: "obiettivo: 500.000",
    },
    cert: {
      eyebrow: "Certificato",
      title: "Il tuo certificato",
      shareText: "Ho riservato il mio pixel nella Pagina dell'Umanità",
      shareHint: "Condividi il tuo certificato: ogni persona che si unisce rende il ritratto più nitido.",
      copyLink: "Copia il link",
      copied: "Link copiato",
      download: "Scarica il certificato",
      notFound: "Pixel non ancora riservato",
    },
    admin: {
      portraitTitle: "Il ritratto di Gandhi",
      portraitNote: "Sostituisci l'immagine base usata nella home e nel mosaico. Consigliata: orizzontale, minimo 800×400, volto centrato. Il mosaico si rigenera automaticamente.",
      upload: "Carica il nuovo ritratto",
      success: "Ritratto aggiornato. Il mosaico si rigenererà a breve.",
    },
    pressForm: {
      eyebrow: "Per giornalisti & creator",
      title: "La lista dei media",
      sub: "Lascia la tua email: ti avviseremo in anteprima quando il ritratto di Gandhi sarà rivelato, a gennaio 2027. Niente spam, una sola storica email.",
      name: "Nome",
      email: "Email",
      outlet: "Testata / Canale (opzionale)",
      submit: "Avvisami alla rivelazione",
      success: "Sei nella lista. Ci vediamo alla rivelazione.",
    },
    adminList: {
      title: "Lista media",
      notify: "Invia annuncio rivelazione",
      confirm: "Inviare l'annuncio della rivelazione a tutti i contatti stampa?",
      sent: "Annuncio inviato",
      empty: "Nessun contatto ancora. Il modulo è nella Sala Stampa.",
      total: "contatti",
    },
    adminPhotos: {
      title: "Volti caricati",
      sub: "Tutte le foto degli utenti, pronte per il mosaico",
      empty: "Nessuna foto caricata ancora.",
      remove: "Rimuovi",
      confirm: "Rimuovere questa foto? Il pixel resterà assegnato ma senza volto.",
      removed: "Foto rimossa. Il mosaico si aggiornerà a breve.",
      photoOf: "Volto di",
      approve: "Approva",
      approved: "Approvata",
      pending: "In attesa di approvazione",
      approvedOk: "Foto approvata: entrerà nel mosaico.",
    },
    adminReset: {
      title: "Pulizia pre-lancio",
      note: "Rimuove i pixel, gli ordini e le foto dell'utente di prova (test@humanity.page). Il tuo pixel [0,0] e tutti i pixel pagati realmente restano intatti. Il contatore riparte dal primo pixel libero.",
      btn: "Rimuovi i dati di prova",
      confirm: "Confermi la pulizia? Verranno rimossi pixel, ordini e foto di test@humanity.page. Il tuo pixel [0,0] resta al suo posto.",
      done: "Dati di prova rimossi. Pixel eliminati",
    },
    privacy: {
      title: "Privacy Policy",
      updated: "Ultimo aggiornamento: agosto 2026",
      s1t: "Titolare del trattamento",
      s1: "Il titolare del trattamento dei dati personali è Marco Orlandi, contattabile all'indirizzo info@marcoorlandi.it.",
      s2t: "Dati raccolti",
      s2: "Raccogliamo: nome e indirizzo email forniti alla registrazione; la fotografia del volto caricata volontariamente; le coordinate dei pixel acquistati. I pagamenti sono gestiti interamente da PayPal: non vediamo né conserviamo i dati della tua carta.",
      s3t: "Finalità",
      s3: "I dati servono a: creare e gestire il tuo account; assegnarti i pixel acquistati; comporre l'opera collettiva «La Pagina dell'Umanità»; inviarti email transazionali (conferma d'acquisto, annuncio della rivelazione).",
      s4t: "Pubblicazione del volto",
      s4: "Caricando la tua foto accetti che il tuo volto e il nome fornito diventino parte pubblica e permanente del mosaico artistico, visibili sul sito e nel certificato digitale condivisibile. Questa è la natura stessa dell'opera.",
      s5t: "Conservazione",
      s5: "I dati sono conservati per l'intera durata del progetto e oltre la rivelazione di gennaio 2027, poiché il mosaico è concepito come un'opera permanente.",
      s6t: "I tuoi diritti",
      s6: "Ai sensi del GDPR (artt. 15-22) puoi chiedere accesso, rettifica o cancellazione dei tuoi dati scrivendo a info@marcoorlandi.it. La rimozione del volto dal mosaico sarà effettuata ove tecnicamente possibile.",
      s7t: "Cookie",
      s7: "Usiamo solo cookie tecnici di sessione, necessari all'autenticazione. Nessun cookie di profilazione o di terze parti pubblicitarie.",
      s8t: "Sicurezza",
      s8: "Adottiamo misure tecniche adeguate: connessioni cifrate (HTTPS), password protette con algoritmi di hashing sicuri, pagamenti criptati tramite PayPal.",
    },
    alts: {
      hero: "Il ritratto di Gandhi composto da 500.000 volti",
      gandhi: "Il ritratto di Gandhi",
      mosaic: "Il mosaico di Gandhi che si compone con i volti",
      face: "Il tuo volto",
      cert: "Certificato del pixel",
    },
    press: {
      eyebrow: "Stampa & Media",
      title: "Sala Stampa",
      sub: "Tutto ciò che serve per raccontare la Pagina dell'Umanità: fatti, cifre, il comunicato ufficiale e i contatti diretti.",
      factsTitle: "I fatti in breve",
      fact1: "pixel nella griglia, uno per volto",
      fact2: "prezzo fisso di ogni pixel, per sempre",
      fact3: "la griglia copre solo la sagoma di Gandhi",
      fact3v: "IL VOLTO",
      fact4: "il formato esatto di ogni volto",
      fact5: "la rivelazione del ritratto di Gandhi",
      fact6: "il sito parla italiano e inglese",
      releaseTitle: "Comunicato stampa",
      releaseDate: "Per diffusione immediata",
      releaseHeadline: "HUMANITY MOSAIC: DAL PRIMO LIBRO STAMPATO IN ITALIA A UNA NUOVA OPERA COLLETTIVA COSTRUITA DALLE PERSONE",
      releaseBody: "Da Subiaco nasce Humanity Mosaic, un progetto digitale internazionale che trasforma la partecipazione di migliaia di persone in un'opera collettiva e in due azioni concrete:\n· sostenere i bambini attraverso un progetto umanitario a loro dedicato\n· contribuire alla realizzazione della Stamperia Antica di Subiaco.\n\nNel 1465, a Subiaco, i monaci tipografi Conrad Sweynheym e Arnold Pannartz introdussero la stampa a caratteri mobili in Italia.\nPiù di cinque secoli dopo, proprio da Subiaco nasce Humanity Mosaic, un progetto che prova nuovamente a mettere insieme tecnologia, persone e memoria.\n\nHumanity Mosaic è un grande mosaico digitale partecipativo. Ogni persona può scegliere il proprio spazio all'interno dell'opera e affidargli un nome, un'immagine, una storia, un pensiero, un progetto o semplicemente il segno del proprio passaggio.\n\nTessera dopo tessera, il mosaico cresce.\nVolti, parole, storie, imprese, artisti, associazioni e persone provenienti da luoghi diversi entrano progressivamente a far parte di una stessa grande immagine.\nMilioni di presenze individuali possono così diventare un'unica opera collettiva.\n\nMa Humanity Mosaic nasce con l'intenzione di non fermarsi allo spazio digitale.\n\nDAL DIGITALE AL REALE\n\nUna parte delle risorse generate dal progetto sarà destinata a due obiettivi concreti.\n\nIl primo riguarda i bambini.\nHumanity Mosaic sosterrà un progetto umanitario dedicato alla tutela dei bambini e al contrasto dell'abbandono minorile.\nPerché se Humanity Mosaic invita ogni persona a trovare il proprio posto all'interno di una grande opera, esiste un posto infinitamente più importante: quello che ogni bambino dovrebbe poter trovare nella vita e negli affetti.\nDa qui nasce una delle frasi simbolo del progetto:\n\nUN POSTO PER TE.\nUN POSTO NEL MONDO PER UN BAMBINO.\n\nIl secondo obiettivo riporta Humanity Mosaic nel luogo dal quale nasce: Subiaco.\nParte delle risorse contribuirà infatti alla realizzazione della Stamperia Antica, un luogo nel quale recuperare e rendere nuovamente vive le tecniche che nel XV secolo cambiarono la storia della diffusione della conoscenza.\nCarta, caratteri mobili, composizione, inchiostrazione, torchio e legatura torneranno a essere non soltanto oggetti da osservare, ma gesti da compiere.\nUn luogo della memoria, dunque, ma soprattutto un luogo del fare, destinato alle nuove generazioni, alle scuole, agli artisti, agli artigiani e ai visitatori.\n\nIl rapporto tra Humanity Mosaic e Subiaco non è quindi soltanto geografico.\nNel 1465 una nuova tecnologia permise alle parole e alle idee di raggiungere un numero di persone prima impensabile. Oggi Humanity Mosaic utilizza una nuova tecnologia per provare a fare il percorso inverso: partire da milioni di persone e ricomporle in un'unica opera.\n\nDal carattere tipografico al pixel.\nDal foglio allo spazio digitale.\nDalla storia individuale all'immagine collettiva.\n\nE dal digitale nuovamente alla materia, attraverso una stamperia che restituisce vita alla carta, ai caratteri e al gesto della stampa.\n\nPer questo il messaggio scelto per Humanity Mosaic è semplice:\n\nIL TUO POSTO LASCIA UN SEGNO.\n\nUn segno dentro l'opera.\nUn segno nella vita di un bambino.\nUn segno nella storia di un luogo che ha contribuito a cambiare il modo in cui l'umanità trasmette le proprie idee.\n\nHUMANITY MOSAIC\nUn gesto digitale. Due segni nel mondo reale",
      copy: "Copia il testo",
      copied: "Testo copiato",
      assetsTitle: "Materiali",
      assetMosaic: "Scarica il mosaico in formazione (JPEG)",
      assetCert: "Vedi un certificato di esempio",
      assetSite: "Visita la pagina pubblica",
      contactTitle: "Contatto stampa",
      contactNote: "Per interviste, collaborazioni con influencer, anteprime del mosaico e materiali in alta risoluzione:",
      quote: "Sii il cambiamento che vuoi vedere nel mondo",
    },
  },
  en: {
    nav: {
      mosaic: "The Mosaic",
      press: "Press",
      mission: "The Mission",
    },
    mosaic: {
      eyebrow: "The portrait taking shape",
      title: "The Mosaic",
      sub: "Every uploaded face lights up a fragment of Gandhi's portrait. The mosaic updates in real time as humanity joins in.",
      faces: "faces",
      zoomHint: "Zoom: mouse wheel · Drag to explore the portrait",
      today: "Today",
      simulation: "2027 Simulation",
      simBadge: "ARTISTIC SIMULATION",
      simNote: "Artistic vision: this is how the portrait will appear when 500,000 faces have joined. Every tile is a face.",
      note: "The unlit tiles on the silhouette await a face. Every golden pixel is a person who said: count me in.",
      galleryTitle: "Faces already in the portrait",
      galleryEmpty: "No approved faces yet. The first face in the portrait could be yours.",
    },
    gandhi: {
      simLink: "See the final mosaic simulation",
    },
    mission: {
      kicker: "YOUR PLACE LEAVES A MARK.",
      lead: "Join Humanity Mosaic.\nBecome part of an artwork built by people from all over the world.\nChoose your space.\nAdd your image, your story, your message.\nLeave a trace of yourself.",
      charity: "Part of the resources generated by the project will be devoted to a humanitarian project for children and to the creation of the Stamperia Antica di Subiaco, in the city where, in 1465, the history of movable-type printing in Italy began.",
      line1: "A PLACE FOR YOU.",
      line2: "A PLACE IN THE WORLD FOR A CHILD.",
      line3: "A PIECE OF HISTORY TO GIVE BACK TO THE FUTURE.",
      gesture: "A digital gesture. Two marks in the real world.",
      signature: "Thousands of people. One single artwork. A trace in the world",
      counterLabel: "pixels sold — part of the proceeds goes to the mission",
      moreLink: "Discover the mission",
    },
    missionPage: {
      eyebrow: "A humanitarian and cultural action",
      title: "The Mission",
      lead: "Humanity Mosaic is not just a collective artwork: every pixel sold leaves a mark in the real world. Part of the resources generated by the project supports two causes: a humanitarian project for children and the printing history of Subiaco.",
      aibiEyebrow: "01 — THE CHILDREN",
      aibiTitle: "A Humanitarian Project",
      aibiBody: "Part of the resources generated by Humanity Mosaic will be devoted to a humanitarian project for children. Because if Humanity Mosaic invites every person to find their place within a great artwork, there is an infinitely more important place: the one every child should be able to find in life and in affection. The details of the project will be announced when the campaign is activated.",
      stampEyebrow: "02 — THE HISTORY",
      stampTitle: "The Ancient Printing House of Subiaco",
      stampBody: "In 1465, within the walls of the monastery of Santa Scolastica in Subiaco, Konrad Sweynheym and Arnold Pannartz printed the first movable-type book in Italy: the Italian history of printing began in that town. The Ancient Printing House project brings those gestures back to life — the wooden press, hand-composed type, paper — and part of Humanity Mosaic's resources will contribute to its creation.",
      capTorchio: "The wooden press, rebuilt as in the fifteenth century",
      capTipi: "Movable type composed by hand, page by page",
      capFogli: "The printed sheets of the Ancient Printing House",
      counterEyebrow: "03 — YOUR CONTRIBUTION",
      counterLabel: "pixels already sold — part of the proceeds goes to the mission",
      counterGoal: "goal: 500,000",
    },
    cert: {
      eyebrow: "Certificate",
      title: "Your certificate",
      shareText: "I claimed my pixel on The Page of Humanity",
      shareHint: "Share your certificate: every person who joins makes the portrait sharper.",
      copyLink: "Copy link",
      copied: "Link copied",
      download: "Download certificate",
      notFound: "Pixel not claimed yet",
    },
    admin: {
      portraitTitle: "The Gandhi portrait",
      portraitNote: "Replace the base image used in the hero and the mosaic. Recommended: landscape, at least 800×400, centered face. The mosaic regenerates automatically.",
      upload: "Upload new portrait",
      success: "Portrait updated. The mosaic will regenerate shortly.",
    },
    pressForm: {
      eyebrow: "For journalists & creators",
      title: "The media list",
      sub: "Leave your email: we will notify you in advance when Gandhi's portrait is revealed, in January 2027. No spam, just one historic email.",
      name: "Name",
      email: "Email",
      outlet: "Outlet / Channel (optional)",
      submit: "Notify me at the reveal",
      success: "You're on the list. See you at the reveal.",
    },
    adminList: {
      title: "Media list",
      notify: "Send reveal announcement",
      confirm: "Send the reveal announcement to all press contacts?",
      sent: "Announcement sent",
      empty: "No contacts yet. The form is in the Press Room.",
      total: "contacts",
    },
    adminPhotos: {
      title: "Uploaded faces",
      sub: "All user photos, ready for the mosaic",
      empty: "No photos uploaded yet.",
      remove: "Remove",
      confirm: "Remove this photo? The pixel will stay assigned but without a face.",
      removed: "Photo removed. The mosaic will update shortly.",
      photoOf: "Face of",
      approve: "Approve",
      approved: "Approved",
      pending: "Pending approval",
      approvedOk: "Photo approved: it will enter the mosaic.",
    },
    adminReset: {
      title: "Pre-launch cleanup",
      note: "Removes pixels, orders and photos of the test user (test@humanity.page). Your pixel [0,0] and all real paid pixels stay untouched. The counter restarts from the first free pixel.",
      btn: "Remove test data",
      confirm: "Confirm cleanup? Pixels, orders and photos of test@humanity.page will be removed. Your pixel [0,0] stays in place.",
      done: "Test data removed. Pixels deleted",
    },
    privacy: {
      title: "Privacy Policy",
      updated: "Last updated: August 2026",
      s1t: "Data controller",
      s1: "The data controller is Marco Orlandi, reachable at info@marcoorlandi.it.",
      s2t: "Data we collect",
      s2: "We collect: name and email address provided at registration; the face photograph you voluntarily upload; the coordinates of purchased pixels. Payments are handled entirely by PayPal: we never see or store your card details.",
      s3t: "Purpose",
      s3: "Your data is used to: create and manage your account; assign your purchased pixels; compose the collective artwork «The Page of Humanity»; send you transactional emails (purchase confirmation, reveal announcement).",
      s4t: "Publication of your face",
      s4: "By uploading your photo you agree that your face and the name you provided become a public and permanent part of the artistic mosaic, visible on the site and on the shareable digital certificate. This is the very nature of the artwork.",
      s5t: "Retention",
      s5: "Data is kept for the entire duration of the project and beyond the January 2027 reveal, as the mosaic is conceived as a permanent artwork.",
      s6t: "Your rights",
      s6: "Under GDPR (art. 15-22) you may request access, rectification or deletion of your data by writing to info@marcoorlandi.it. Removal of a face from the mosaic will be carried out where technically possible.",
      s7t: "Cookies",
      s7: "We only use technical session cookies, required for authentication. No profiling or third-party advertising cookies.",
      s8t: "Security",
      s8: "We adopt adequate technical measures: encrypted connections (HTTPS), passwords protected with secure hashing algorithms, payments encrypted via PayPal.",
    },
    alts: {
      hero: "The portrait of Gandhi composed of 500,000 faces",
      gandhi: "The portrait of Gandhi",
      mosaic: "Gandhi's mosaic taking shape with every face",
      face: "Your face",
      cert: "Pixel certificate",
    },
    press: {
      eyebrow: "Press & Media",
      title: "Press Room",
      sub: "Everything you need to tell the story of The Page of Humanity: facts, figures, the official release and direct contacts.",
      factsTitle: "Key facts",
      fact1: "pixels in the grid, one for each face",
      fact2: "fixed price per pixel, forever",
      fact3: "the grid covers only Gandhi's silhouette",
      fact3v: "THE FACE",
      fact4: "the exact format of every face",
      fact5: "the reveal of Gandhi's portrait",
      fact6: "the site speaks Italian and English",
      releaseTitle: "Press release",
      releaseDate: "For immediate release",
      releaseHeadline: "HUMANITY MOSAIC: FROM THE FIRST BOOK PRINTED IN ITALY TO A NEW COLLECTIVE ARTWORK BUILT BY PEOPLE",
      releaseBody: "From Subiaco comes Humanity Mosaic, an international digital project that turns the participation of thousands of people into a collective artwork and into two concrete actions:\n· supporting children through a humanitarian project dedicated to them\n· contributing to the creation of the Ancient Printing House of Subiaco.\n\nIn 1465, in Subiaco, the monk printers Conrad Sweynheym and Arnold Pannartz introduced movable-type printing to Italy.\nMore than five centuries later, it is once again from Subiaco that Humanity Mosaic is born — a project that tries once more to bring together technology, people and memory.\n\nHumanity Mosaic is a great participatory digital mosaic. Every person can choose their own space within the artwork and entrust it with a name, an image, a story, a thought, a project or simply the sign of their passage.\n\nTile after tile, the mosaic grows.\nFaces, words, stories, enterprises, artists, associations and people from different places progressively become part of one single great image.\nMillions of individual presences can thus become a single collective artwork.\n\nBut Humanity Mosaic is born with the intention of not stopping at the digital space.\n\nFROM DIGITAL TO REAL\n\nPart of the resources generated by the project will be devoted to two concrete goals.\n\nThe first concerns children.\nHumanity Mosaic will support a humanitarian project dedicated to protecting children and fighting child abandonment.\nBecause if Humanity Mosaic invites every person to find their place within a great artwork, there is an infinitely more important place: the one every child should be able to find in life and in affection.\nThis is where one of the project's symbolic phrases comes from:\n\nA PLACE FOR YOU.\nA PLACE IN THE WORLD FOR A CHILD.\n\nThe second goal brings Humanity Mosaic back to the place it comes from: Subiaco.\nPart of the resources will in fact contribute to the creation of the Ancient Printing House, a place in which to recover and bring back to life the techniques that in the 15th century changed the history of the spread of knowledge.\nPaper, movable type, composition, inking, press and binding will once again be not just objects to observe, but gestures to perform.\nA place of memory, then, but above all a place of doing, destined for new generations, schools, artists, artisans and visitors.\n\nThe relationship between Humanity Mosaic and Subiaco is therefore not only geographic.\nIn 1465 a new technology allowed words and ideas to reach a number of people previously unthinkable. Today Humanity Mosaic uses a new technology to try the reverse journey: starting from millions of people and recomposing them into a single artwork.\n\nFrom the typographic character to the pixel.\nFrom the sheet to the digital space.\nFrom the individual story to the collective image.\n\nAnd from digital back to matter, through a printing house that gives life back to paper, to type and to the gesture of printing.\n\nThis is why the message chosen for Humanity Mosaic is simple:\n\nYOUR PLACE LEAVES A MARK.\n\nA mark inside the artwork.\nA mark in a child's life.\nA mark in the history of a place that helped change the way humanity transmits its ideas.\n\nHUMANITY MOSAIC\nA digital gesture. Two marks in the real world",
      copy: "Copy the text",
      copied: "Text copied",
      assetsTitle: "Assets",
      assetMosaic: "Download the mosaic in progress (JPEG)",
      assetCert: "View a sample certificate",
      assetSite: "Visit the public page",
      contactTitle: "Press contact",
      contactNote: "For interviews, influencer collaborations, mosaic previews and high-resolution materials:",
      quote: "Be the change you wish to see in the world",
    },
  },
};
